import { Vue, Component, Watch, Prop, Inject } from 'vue-property-decorator';
import { cloneDeep, noop } from 'lodash';
import AddButton from '../addButton';
import BackGround from './backGround';
import Blank from './blank';
import IconMenu from './iconMenu';
import LabelClass from './labelClass';
import Member from './member';
import Order from './order';
import PageVideo from './pageVideo';
import Picture from './picture';
import Propagate from './propagate';
import Search from './search';
import ShowWindow from './showWindow';
import QiKanShowWindow from './qiKanShowWindow';
import WeiGroup from './weiGroup';
import Site from './site';
import Swiper from './swiper';
import TextTitle from './text';
import Vguider from './vGuider';
import Video from './video';
import BottomButton from './bottomButton';
import HoverIcon from './hoverIcon';
import ProductInfo from './productInfo';
import ChooseSku from './chooseSku';
import SellOutText from './sellOutText';
import ProductPicture from './productPicture';
import ButtonBar from './productInfoButton';
import Guide from './guide';
import HotAd from './hotAd';
import HotStyle from './hotStyle';
import style from './style.vue';
import HotBg from '@/views/components/shopDisplaySketchMap/display/hotBg';

export enum FieldTypeList {
  backGround = 'backGround',
  blank = 'blank',
  Blank = 'Blank',
  iconMenu = 'iconMenu',
  labelClass = 'LabelClass',
  member = 'member',
  miniPage = 'miniPage',
  order = 'order',
  pageVideo = 'pageVideo',
  picture = 'picture',
  propagate = 'Propagate',
  search = 'search',
  ShowWindow = 'ShowWindow',
  WeiGroup = 'weiGroup',
  ShowWindowGroup = 'ShowWindowGroup',
  QiKanShowWindow = 'QiKanShowWindow',
  site = 'Site',
  swiper = 'Swiper',
  text = 'text',
  vGuider = 'vGuider',
  video = 'video',
  HoverIcon = 'HoverIcon',
  ProductInfo = 'ProductInfo',
  ChooseSku = 'ChooseSku',
  SellOutText = 'SellOutText',
  ProductPicture = 'ProductPicture',
  ButtonBar = 'ButtonBar',
  Guide = 'guide',
  HotAd = 'HotAd',
  HotBg = 'HotBg',
  HotStyle = 'HotStyle',
}

// 不能拖动的元素
const DisabledDraggable = ['backGround', 'HoverIcon', 'HotAd', 'HotBg', 'HotStyle'];

// 上层定位的元素
const AbsoluteTop = ['HoverIcon', 'ButtonBar', 'guide', 'miniPage'];

// 选中状态在在自身而不是在父元素上的 需要点击自身再从自身发出事件
const InnerActive = ['HotAd'];

const bangsTitle = ['', '商城页示意图1', '个人中心页示意图', '微页面示意图', '商品详情示意图', 'HOT页面示意图', '', '', '', '', ''];

const DisplayType = {
  backGround: { label: '店铺信息', isShowDel: false },
  member: { label: '入会及权益', isShowDel: false },
  vGuider: { label: '分销申请', isShowDel: false },
  order: { label: '订单中心', isShowDel: false },
  iconMenu: { label: '图标导航', isShowDel: true },
  video: { label: '视频', isShowDel: true },
  blank: { label: '辅助空白', isShowDel: true },
  Blank: { label: '辅助空白', isShowDel: true },
  text: { label: '文字标题', isShowDel: true },
  Propagate: { label: '图文广告', isShowDel: true },
  Swiper: { label: '店铺形象图', isShowDel: false },
  Site: { label: '店铺信息', isShowDel: false },
  ShowWindow: { label: '商品橱窗', isShowDel: true },
  QiKanShowWindow: { label: '期刊橱窗', isShowDel: true },
  weiGroup: { label: '多页橱窗', isShowDel: true },
  search: { label: '搜索商品', isShowDel: true },
  LabelClass: { label: '分类导航', isShowDel: true },
  picture: { label: '图片', isShowDel: true },
  pageVideo: { label: '视频', isShowDel: true },
  miniPage: { label: '页面设置', isShowDel: false },
  SellOutText: { label: '售罄文本', isShowDel: false },
  ProductPicture: { label: '图片', isShowDel: true },
  BottomBar: { label: '按钮', isShowDel: false },
  ShowWindowGroup: { label: '商品橱窗', isShowDel: true },
  guide: { label: '小程序引导', isShowDel: true },
  HotAd: { label: '广告位', isShowDel: false },
  HotBg: { label: '背景', isShowDel: false },
  HotStyle: { label: '展示方式', isShowDel: false },
};

enum PAGE {
  SHOP = 1,
  CENTER,
  MINI,
  PRO_INFO,
  HOT,
  CLOUD_MALL_SHOP,
  CLOUD_MALL_CENTER,
  CLOUD_MALL_MINI,
  SG_CLOUD_MALL_MINI,
  CLOUD_HOT,
}

@Component({
  components: {
    BackGround,
    Blank,
    IconMenu,
    LabelClass,
    Member,
    Order,
    PageVideo,
    Picture,
    Propagate,
    Search,
    ShowWindow,
    WeiGroup,
    QiKanShowWindow,
    Site,
    Swiper,
    TextTitle,
    Vguider,
    Video,
    AddButton,
    BottomButton,
    HoverIcon,
    ProductInfo,
    SellOutText,
    ChooseSku,
    ProductPicture,
    ButtonBar,
    Guide,
    HotAd,
    HotStyle,
  },
  mixins: [style],
})
export default class ShopDisplay extends Vue {
  // 主题
  @Prop({ default: 1 })
  themeCode: number;

  // 数据源
  @Prop()
  value: Array<ItemObject>;

  // 是否可拖动 默认可拖动
  @Prop()
  disabled: boolean;

  // 默认背景色
  @Prop()
  defaultBg: string;

  // 1 镜千-店铺 2 镜千-个人中心 3 镜千-微页面 4 镜千/云单-商详 5 镜千-hot 6 云单-商城页 7 云单-个人中心 8 云单(网点)-微页面 9 云单(网点组)-微页面 10 云单 hot
  @Prop({ default: 0 })
  fromPage: number;

  // 不显示标签的元素
  @Prop({ default: () => [] })
  disabledLabel: string[];

  // 不参与点击添加选中状态的
  @Prop({ default: () => [] })
  disabledActived: string[];

  // 是否展示按钮
  @Prop({ default: false })
  showButton: boolean;

  @Prop({ default: () => { } })
  buttonInfo: MiniPageButtonInfo;

  @Prop({ default: false })
  classAd: boolean;

  // 仅展示不可拖动和点击
  @Prop({ default: false })
  readOnly: boolean;

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Prop({ default: 2 })
  mode: number;

  @Prop({ default: true })
  isDisplay: Boolean;

  @Prop({
    default() {
      return [];
    },
  })
  actData: DisplayData[];

  showBangs = false;

  @Inject({
    default: () => {
      return () => {
        return { selected: -1 };
      };
    },
  })
  shopDisplayTree;

  data: Array<ItemObject> = [];

  // data  历史数据
  dataHistory: Array<ItemObject> = [];

  copyData: Array<ItemObject> = [];

  // 拖动排序时
  onSort(val) {
    switch (this.fromPage) {
      case PAGE.PRO_INFO:
        this.productInfoSort();
        break;
      default:
        this.$emit('input', this.data);
        // copyData按照data实时排序
        const list = this.data.map((i) => {
          return i._key;
        });
        this.copyData.sort((a, b) => {
          return list.indexOf(a._key) - list.indexOf(b._key);
        });
        this.$emit('changeData', this.copyData);
        break;
    }
  }

  productInfoSort() {
    const temp = this.data.filter(v => !!v.baseSort);
    if (this.data[0].fieldType !== FieldTypeList.ProductInfo || !temp.every((v, i) => v.baseSort === i + 1)) {
      this.data = this.dataHistory;
      this.$emit('input', this.data);
      this.$message.warning('无效排序');
      return;
    }
    const baseSortIndex1 = this.data.findIndex(v => v.baseSort === 1);
    const baseSortIndex2 = this.data.findIndex(v => v.baseSort === 2);
    const baseSortIndex3 = this.data.findIndex(v => v.baseSort === 3);
    const baseSortIndex4 = this.data.findIndex(v => v.baseSort === 4);
    const baseSortIndex5 = this.data.findIndex(v => v.baseSort === 5);
    const baseSortIndex6 = this.data.findIndex(v => v.baseSort === 6);
    const arr = [baseSortIndex1, baseSortIndex2, baseSortIndex3, baseSortIndex4, baseSortIndex5, baseSortIndex6];
    this.data = this.data.map((v, i) => {
      if (v.fieldType === 'ProductPicture') {
        v.position = arr.findIndex(s => s > i) === -1 ? 6 : arr.findIndex(s => s > i);
      }
      return v;
    });
    this.$emit('input', this.data);
  }

  // 字体颜色
  get fontColor() {
    return this.themeCode > 3 ? '#ffffff' : '#000000';
  }

  // 黑色或白色背景
  get backGround() {
    return this.themeCode > 3 ? '#000000' : '#ffffff';
  }

  get themeBg() {
    let result = '';
    if (this.fromPage === PAGE.SHOP || this.fromPage === PAGE.CENTER || this.fromPage === PAGE.CLOUD_MALL_SHOP || this.fromPage === PAGE.CLOUD_MALL_CENTER) {
      result = this.backGround;
    } else {
      result = this.defaultBg;
    }
    return result;
  }

  // 获取有边距
  get getPaddingRight() {
    let result = 124;
    this.disabled && (result = 0);
    this.fromPage === PAGE.MINI && (result = 124);
    this.readOnly && (result = 0);
    this.classAd && (result = 2);
    return result;
  }

  get buttonPaddingBottom() {
    switch (this.fromPage) {
      case PAGE.CLOUD_MALL_MINI:
      case PAGE.MINI:
      case PAGE.SG_CLOUD_MALL_MINI:
        return this.showButton ? 186 : 136;
      case PAGE.CLOUD_MALL_SHOP:
        return 181;
      case PAGE.CLOUD_MALL_CENTER:
        return 90;
      default:
        return 56;
    }
}
  get pageHeight() {
    switch (this.fromPage) {
      case PAGE.CLOUD_MALL_MINI:
      case PAGE.MINI:
      case PAGE.SG_CLOUD_MALL_MINI:
        return 73;
      case PAGE.CLOUD_MALL_SHOP:
        return 74;
      case PAGE.CLOUD_MALL_CENTER:
        return 87;
      default:
        return 95;
    }
  }

  // 获取上面的内边距
  getPaddingTop() {
    return this.fromPage === 2 || this.fromPage === 7 ? 148 : this.fromPage === 5 || this.fromPage === 10 ? 36 : 0;
  }

  // 获取下面的内边距
  getPaddingBottom() {
    return this.fromPage === 4 ? 60 : this.fromPage === 3 ? 40 : 0;
  }

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    this.dataHistory = cloneDeep(n);
    this.copyData = cloneDeep(this.actData);
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      // 获取原始数据
      this.data = n;
    } else {
      this.$forceUpdate();
    }
  }

  // 滚动到选定位置
  scrollToActived() {
    this.$nextTick(() => {
      if (this.$el.querySelector('.is-actived')) {
        this.$el.querySelector('.is-actived').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  dealData(index) {
    const lastIndex = this.dataHistory.findIndex(v => v.isActived);
    // 由于ShowWindow和ShowWindowGroup数据会在选择后多余productList，所以在比较的时候进行删除
    const arr = this.data.map((item) => {
      if (item.fieldType === 'ShowWindow' || item.fieldType === 'ShowWindowGroup') {
        delete item?.desc?.productList;
        item.desc.caseGroup = (item.desc.caseGroup || []).map((v) => {
          if (v.productList) {
            delete v.productList;
          }
          return v;
        });
      }
      return item;
    });
    const newArr = this.copyData.map((item) => {
      if (item.fieldType === 'ShowWindow' || item.fieldType === 'ShowWindowGroup') {
        delete item?.desc?.productList;
        item.desc.caseGroup = (item.desc.caseGroup || []).map((v) => {
          if (v.productList) {
            delete v.productList;
          }
          return v;
        });
      }
      return item;
    });
    if (JSON.stringify(arr[lastIndex]?.desc) !== JSON.stringify(newArr[lastIndex]?.desc)) {
      this.$confirm('当前修改内容尚未保存，是否继续切换？').then(
        (res) => {
          // 未保存切换，数据应该恢复
          if (res === 'confirm') {
            this.$set(
              this,
              'data',
              this.copyData.map((v, i) => {
                v.isActived = i === index;
                return v;
              }),
            );
            this.$emit('input', this.data);
          }
        },
        () => {
          // 取消切换，应留在当前页面且数据不变
          this.data = this.data.map((v, i) => {
            v.isActived = i === lastIndex;
            return v;
          });
          this.$emit('input', this.data);
        },
      );
    } else {
      this.data = this.data.map((v, i) => {
        v.isActived = i === index;
        return v;
      });
      this.$emit('input', this.data);
    }
  }

  // 选中
  onActive(index) {
    if (this.disabledActived.includes(this.data[index].fieldType) || (this.disabled && this.fromPage !== PAGE.MINI) || this.readOnly) {
      return;
    }
    if (this.fromPage === 6 || this.fromPage === 7) {
      this.dealData(index);
    } else {
      this.data = this.data.map((v, i) => {
        v.isActived = i === index;
        return v;
      });
      this.$emit('input', this.data);
    }
  }

  // 添加
  onAddItem(val: ItemArray) {
    const activedIndex = this.data.findIndex(v => v.isActived);
    this.data = this.data.map((v, i) => {
      v = Object.assign(v, { isActived: false });
      return v;
    });

    val[val.length - 1].isActived = true;
    if (activedIndex === -1) {
      this.data = this.data.concat(val);
      this.copyData = this.copyData.concat(val);
    } else {
      this.data.splice(activedIndex + 1, 0, ...val);
      this.copyData.splice(activedIndex + 1, 0, ...val);
    }
    this.scrollToActived();
    this.$emit('input', this.data);
    this.$emit('changeData', this.copyData);
  }

  // 删除
  onDel(index: number) {
    this.$confirm('确认删除该组件？').then((res) => {
      if (res === 'confirm') {
        // setTimeout(() => {
        const delItem = this.data.splice(index, 1)[0];
        const delCopyItem = this.copyData.splice(index, 1)[0];
        if (this.data[index - 1] && this.data[index - 1].fieldType.toLocaleLowerCase() === 'blank' && delItem.fieldType.toLocaleLowerCase() !== 'blank' && this.fromPage !== 4) {
          this.data.splice(index - 1, 1);
        }
        if (this.copyData[index - 1] && this.copyData[index - 1].fieldType.toLocaleLowerCase() === 'blank' && delCopyItem.fieldType.toLocaleLowerCase() !== 'blank' && this.fromPage !== 4) {
          this.copyData.splice(index - 1, 1);
        }
        this.data = this.data.map((v) => {
          v.isActived = false;
          return v;
        });
        this.copyData = this.copyData.map((v) => {
          v.isActived = false;
          return v;
        });
        this.$emit('input', this.data);
        this.$emit('changeData', this.copyData);
        // }, 0);
      }
    });
  }

  computedIsShowLabel(val): boolean {
    switch (val.fieldType) {
      case 'search':
      case 'HoverIcon':
        return false;
      case 'blank':
      case 'Blank':
        return val.desc.bHeight === 80;
      case 'iconMenu':
        return !!(val.desc.list && val.desc.list.length);
      case 'text':
        return !!(val.desc.title && val.desc.content);
      default:
        return true;
    }
  }

  computedIsShowDel(val): boolean {
    return Object.keys(DisplayType).includes(val.fieldType) && DisplayType[val.fieldType].isShowDel;
  }

  isShowInnerLabel(val) {
    return this.disabled && (val.fieldType == 'Propagate' || val.fieldType == 'ShowWindow' || val.fieldType == 'QiKanShowWindow' || val.fieldType == 'weiGroup') && val.isActived;
  }

  renderInnerLabel(h, val) {
    let name = '';
    switch (val.fieldType) {
      case FieldTypeList.ShowWindow:
        name = val.desc.caseName || '商品橱窗';
        break;
      case FieldTypeList.ShowWindowGroup:
        const findCase = val.desc.caseGroup.find(v => this.shopDisplayTree().selected === (this.fromPage === PAGE.SHOP ? v.sgwpId : v.sgmpId));
        name = findCase ? findCase.caseName || '商品橱窗组' : '商品橱窗组';
        break;
      case FieldTypeList.QiKanShowWindow:
        name = val.desc.qiKanName || '期刊橱窗';
        break;
      case FieldTypeList.WeiGroup:
        name = val.desc.title || '多页橱窗';
        break;
      case FieldTypeList.propagate:
        name = val.desc.pName || '广告位';
        break;
      case FieldTypeList.video:
        name = val.desc.vName || '视频位';
        break;
      default:
        break;
    }
    return <div class="inner-label">{name}</div>;
  }
  get dealPage() {
    return this.fromPage && (this.fromPage === 1 || this.fromPage === 2)
  }
  renderDelAndLabel(h, value, index) {
    return [
      this.computedIsShowLabel(value) && !this.classAd && <div class="label-button">{Object.keys(DisplayType).includes(value.fieldType) && DisplayType[value.fieldType].label}</div>,
      this.computedIsShowDel(value) && !this.classAd && (
        <div class="del-button" onClick={this.onDel.bind(this, index)}>
          删除
        </div>
      ),
    ];
  }

  render(h) {
    return (
      <div class={{ 'display-content r-mt-40': this.dealPage&&this.isDisplay, 'height-100': true }} style="flex-flow:column">
        {bangsTitle[this.fromPage] && !this.disabled&&!this.dealPage && (
          <p class="nav-title nav-banges">
            <span>{bangsTitle[this.fromPage]}</span>
            <el-switch v-model={this.showBangs} active-text="刘海屏" />
          </p>
        )}

        <div class={{ 'relative-position overflow-hidden flex flex1': true, 'display-content ': this.dealPage&&this.isDisplay }} style={{ 'height': this.fromPage===PAGE.HOT||this.fromPage===PAGE.MINI?'95%':this.dealPage?'':'100%', 'flex-flow:column': true }} >
          {/* 底层背景 */}
          <div class="width-100 relative-position scroll-y overflow-hidden-x flex1" style={`padding-bottom: ${this.buttonPaddingBottom}px;height:${this.pageHeight}%`}>
            {/* 上层脱离文档流元素 */}
            {this.showBangs && <div class="bangs" style="left: calc((100% - 124px)/2 - 100px);top:0" />}
            {this.data
              .filter(v => AbsoluteTop.includes(v.fieldType))
              .map((d, i) => {
                let item = <span></span>;
                switch (d.fieldType) {
                  case FieldTypeList.HoverIcon:
                    item = (
                      <HoverIcon
                        value={d}
                        key={i}
                        fromPage={this.fromPage}
                        showButton={this.showButton}
                        disabled={this.disabled}
                        position={this.getPaddingRight}
                        onClick={this.onActive.bind(
                          this,
                          this.data.findIndex(v => v.fieldType === 'HoverIcon'),
                        )}
                        onDel={this.onDel.bind(
                          this,
                          this.data.findIndex(v => v.fieldType === 'HoverIcon'),
                        )}
                      />
                    );

                    break;
                  case FieldTypeList.ButtonBar:
                    item = <ButtonBar value={d} key={i} />;
                    break;
                  case FieldTypeList.Guide:
                    item = (
                      <Guide
                        value={d}
                        key={i}
                        position={this.getPaddingRight}
                        onClick={this.onActive.bind(
                          this,
                          this.data.findIndex(v => v.fieldType === 'guide'),
                        )}
                        onDel={this.onDel.bind(
                          this,
                          this.data.findIndex(v => v.fieldType === 'guide'),
                        )}
                      />
                    );
                    break;
                  default:
                    break;
                }
                return item;
              })}
            <div class="map-bg" style={!this.classAd ? `background: ${this.themeBg};width: calc(100% - ${this.getPaddingRight}px);` : `width: calc(100% - ${this.getPaddingRight}px);border: 1px dashed #00000087`}></div>
            <draggable
              draggable={this.disabled ? '.draggable-meti' : '.draggable-item'}
              scroll={true}
              delay={25}
              v-model={this.data}
              scroll-sensitivity={150}
              force-fallback={true}
              class="draggable"
              onChange={val => this.onSort(val)}
              style={
                !this.classAd ? `color: ${this.fontColor};padding-top: ${this.getPaddingTop()}px;margin: 0 auto;padding-right: ${this.getPaddingRight}px;padding-bottom: ${this.fromPage === PAGE.PRO_INFO ? 60 : 0}px` : 'padding:10px 0;margin: 0 auto;'
              }>
              {this.data.map((v, i) => {
                // 由于key值问题导致图片拖动会变成原有位置的图片，父组件数据新增key值用来识别
                let item = <span></span>;
                let backGroundStyle = '';
                // 中间层 拖动元素
                switch (v.fieldType) {
                  case FieldTypeList.backGround:
                    item = <BackGround value={v} key={v.key} disabled={this.disabled} />;
                    backGroundStyle = `width: calc(100% - ${this.disabled ? 0 : 124}px)`;
                    // backGroundStyle = `background-image: url(${v.desc.val + "?imageView2/1/w/750/h/400"});background: ${
                    //   v.desc.val
                    // };`;
                    break;
                  case FieldTypeList.HotBg:
                    backGroundStyle = `width: calc(100% - ${this.disabled ? 0 : 124}px)`;
                    item = <HotBg value={v} key={v._key} disabled={this.disabled} />;
                    break;
                  case FieldTypeList.blank:
                  case FieldTypeList.Blank:
                    item = <Blank value={v} key={v._key} />;
                    break;
                  case FieldTypeList.iconMenu:
                    item = <IconMenu value={v} themeCode={this.fromPage === PAGE.MINI ? 1 : this.themeCode} key={v._key} />;
                    break;
                  case FieldTypeList.labelClass:
                    item = <LabelClass value={v} key={v._key} fontColor={this.fontColor} themeCode={this.themeCode} />;
                    break;
                  case FieldTypeList.member:
                    item = <Member value={v} themeCode={this.themeCode} key={v._key} />;
                    break;
                  case FieldTypeList.order:
                    item = <Order value={v} themeCode={this.themeCode} key={v._key} />;
                    break;
                  case FieldTypeList.pageVideo:
                    item = <PageVideo value={v} key={v._key} />;
                    break;
                  case FieldTypeList.picture:
                    item = <Picture value={v} key={v._key} />;
                    break;
                  case FieldTypeList.propagate:
                    item = <Propagate value={v} themeCode={this.fromPage === PAGE.MINI ? 1 : this.themeCode} key={v._key} />;
                    break;
                  case FieldTypeList.search:
                    item = <Search value={v} key={v._key} />;
                    break;
                  case FieldTypeList.site:
                    item = <Site value={v} themeCode={this.themeCode} key={v._key} fromPage={this.fromPage} />;
                    break;
                  case FieldTypeList.text:
                    item = <TextTitle value={v} themeCode={this.themeCode} key={v._key} />;
                    break;
                  case FieldTypeList.vGuider:
                    item = <Vguider value={v} themeCode={this.themeCode} key={v._key} />;
                    break;
                  case FieldTypeList.video:
                    item = <Video value={v} key={v._key} />;
                    break;
                  case FieldTypeList.ShowWindow:
                  case FieldTypeList.ShowWindowGroup:
                    item = <ShowWindow value={v} themeCode={this.fromPage === PAGE.MINI ? 1 : this.themeCode} key={v._key} backGroundColor={this.themeBg} fromPage={this.fromPage} />;
                    break;
                  case FieldTypeList.QiKanShowWindow:
                    item = <QiKanShowWindow value={v} themeCode={this.fromPage === PAGE.MINI ? 1 : this.themeCode} key={v._key} backGroundColor={this.themeBg} fromPage={this.fromPage} />;
                    break;
                  case FieldTypeList.WeiGroup:
                    item = <WeiGroup value={v} themeCode={this.themeCode} key={v._key} backGroundColor={this.themeBg} fromPage={this.fromPage} />;
                    break;
                  case FieldTypeList.ProductInfo:
                    item = <ProductInfo value={v} mainImage={i} key={v._key} />;
                    break;
                  case FieldTypeList.ChooseSku:
                    item = <ChooseSku value={v} key={v._key} />;
                    break;
                  case FieldTypeList.SellOutText:
                    item = <SellOutText value={v} key={v._key} />;
                    break;
                  case FieldTypeList.ProductPicture:
                    const marginBottom = i === this.data.length - 1 || (this.data[this.data.length - 1].fieldType === 'ButtonBar' && i === this.data.length - 2);
                    item = <ProductPicture value={v} key={v._key} style={{ marginBottom: marginBottom ? '0px' : '0px' }} />;
                    break;
                  case FieldTypeList.Guide:
                    item = <Guide value={v} key={v._key} disabled={!!this.disabled} />;
                    break;
                  case FieldTypeList.HotAd:
                    backGroundStyle = 'pointer-events: none';
                    item = (
                      <HotAd
                        value={v}
                        key={v._key}
                        classAd={this.classAd}
                        disabled={this.disabled}
                        onClick={this.onActive.bind(
                          this,
                          this.data.findIndex(v => v.fieldType === FieldTypeList.HotAd),
                        )}
                      />
                    );
                    break;
                  case FieldTypeList.HotStyle:
                    item = <HotStyle value={v} key={v._key} />;
                    break;
                  default:
                    break;
                }
                return (
                  <div
                    v-show={!AbsoluteTop.includes(v.fieldType)}
                    class={[!DisabledDraggable.includes(v.fieldType) && 'draggable-item', v.isActived && !InnerActive.includes(v.fieldType) && 'is-actived', `center-${v.fieldType}`]}
                    onClick={this.onActive.bind(this, i)}
                    style={backGroundStyle}>
                    {item}
                    {v.isActived && !this.disabled && !this.disabledLabel.includes(v.fieldType) && this.renderDelAndLabel(h, v, i)}
                    {v.isActived && this.readOnly && this.renderInnerLabel(h, v)}
                  </div>
                );
              })}
            </draggable>
            {this.showButton && (this.fromPage == 8 || this.fromPage == 3 || this.fromPage == 9) && <BottomButton value={this.buttonInfo} fromPage={this.fromPage} isDisplay={this.isDisplay} style={`background: ${this.defaultBg};`} />}
          </div>
          {!this.disabled && this.fromPage && !(this.dealPage) && (
            <div class="bottom-button-display" ref="bottomButton" style={`padding-top: ${this.showButton ? 0 : ''}`}>
              <AddButton v-model={this.data} fromPage={this.fromPage} onAdd={this.onAddItem.bind(this)} class="flex" style={`padding-top: ${this.showButton ? '12px' : ''}`} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
